/**
 * Utility functies voor document verwerking
 */

/**
 * Controleert of een bestand een PDF is op basis van URL en bestandsnaam
 */
export function isPdf(url: string, bestandsnaam: string): boolean {
  return (
    url.toLowerCase().endsWith('.pdf') ||
    url.toLowerCase().includes('.pdf?') ||
    bestandsnaam.toLowerCase().endsWith('.pdf')
  );
}

/**
 * Bepaalt het juiste FontAwesome icon voor een document type
 */
export function getDocumentIcon(url: string, bestandsnaam: string): string {
  return isPdf(url, bestandsnaam) ? 'far fa-file-pdf' : 'far fa-external-link';
}

/**
 * Bepaalt de juiste Tailwind color class voor een document icon
 */
export function getDocumentIconColor(url: string, bestandsnaam: string): string {
  return isPdf(url, bestandsnaam) ? 'text-red-500' : 'text-primary';
}
